// src/components/pages/Pessoa/profile/pessoaProfiles.js

import { tabelaPreco } from '../../../../api/pessoa';

export const pessoaProfiles = {
    pessoa: {
        key: 'pessoa',
        labelForm: 'Gestão de Pessoas',
        initialTabKey: 'cabecalho',
        tabs: {
            cabecalho: true,
            fisica: true,
            nomes: true,

            juridica: true,
            financeiro: true,
            tabelaPrecos: true,
            enderecos: true,
            emails: true,
            telefones: true,
            usuario: false,
            colaborador: false,
            funcionarios: true,
            filiais: true,
        },
        show: {
            cabecalho: {
                colaborador: true,
                usuario: true,
                inscricaoEstadualST: true,
                simplesNacional: true,
                vinculoFinanceiro: true,
                fabricante: true,
                pixDefinido: true,
                pixPadrao: true,
            },
        },
    },

    colaborador: {
        key: 'colaborador',
        labelForm: 'Gestão de Colaboradores',
        initialTabKey: 'cabecalho',
        tabs: {
            cabecalho: true,
            fisica: true,
            nomes: false,
            juridica: false,
            financeiro: false,
            tabelaPrecos: false,
            enderecos: true,
            emails: true,
            telefones: true,
            usuario: false,
            colaborador: true,
            funcionarios: false,
            filiais: true,
        },
        show: {
            cabecalho: {
                colaborador: true,
                usuario: true,
                inscricaoEstadualST: false,
                simplesNacional: false,
                vinculoFinanceiro: true,
                fabricante: false,
                pixDefinido: true,
                pixPadrao: true,
            },
        },
    },

    usuario: {
        key: 'usuario',
        labelForm: 'Gestão de Usuários',
        initialTabKey: 'cabecalho',
        tabs: {
            cabecalho: true,
            fisica: false,
            nomes: false,
            juridica: false,
            financeiro: false,
            documentos: false,
            enderecos: false,
            emails: false,
            telefones: false,
            tabelaPrecos: false,
            usuario: true,
            colaborador: false,
            funcionarios: false,
            filiais: true,
        },
        show: {
            cabecalho: {
                colaborador: false,
                usuario: true,
                inscricaoEstadualST: false,
                simplesNacional: false,
                vinculoFinanceiro: false,
                fabricante: false,
                pixDefinido: false,
                pixPadrao: false,
            },
        },
    },
};
